import React from 'react';
import { IconButton } from '@mui/material';
import { IconCameraSolid } from '@roku-web-ui/rds-icons';
import { colors } from '@roku-web-ui/rds-theme';

import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';
import { dispatchEvent } from 'modules/globalEvents';

import { AppDeviceLeaf } from 'types/common/leaf';

interface ScreenshotProps {
  leafId: AppDeviceLeaf['id'];
}

export const Screenshot = ({ leafId }: ScreenshotProps) => {
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title="Take a photo" placement="top">
      <IconButton
        aria-label="take-photo"
        data-testid="button-take-photo"
        onClick={() => {
          dispatchEvent({
            leafId,
            event: 'TAKE_SCREENSHOT',
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leafId,
              interaction: 'photo',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconCameraSolid sx={{ color: colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
